<template>
  <div class="full-height">
    <home-header></home-header>
    <intro></intro>
    <foobar-search></foobar-search>
    <foobar-news></foobar-news>
    <social-links></social-links>
    <home-footer></home-footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import config from '@/components/utils/Config'
  import Intro from '@/components/partials/IntroLarge'
  import HomeHeader from '@/components/home/Header'
  import HomeFooter from '@/components/home/Footer'

  import SocialLinks from '@/components/home/SocialLinks'

  import FoobarSearch from '../components/foobar/FoobarSearch'
  import FoobarNews from '@/components/foobar/FoobarNews'

  Vue.use(VueAxios, axios)

  export default {
    components: {
      Intro,
      HomeHeader,
      FoobarNews,
      FoobarSearch,
      SocialLinks,
      HomeFooter
    },
    created () {
      Vue.axios.get(config.urls.check_all)
      .then((response) => {
        this.$store.commit('updateAuth', response.data)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Home.vue?ec96b8fe